import React from 'react';

const AdminHome = () => {
    return (
        <>
            
        </>
    );
};

export default AdminHome;
